import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../utils/styles';
import { SectionContainer, SectionTitle } from '../styles';
import { Container, ImageSection, Image, TextContent, ImageSectionWrapper, } from './styles';
export const About = ({ section }) => {
    const { featuredText, completeDescription, pageTitle, image } = section;
    const showContent = featuredText || completeDescription || pageTitle;
    return (_jsxs(Container, { children: [image && (_jsx(ImageSectionWrapper, { className: classNames({
                    pb: !showContent,
                }), children: _jsx(ImageSection, { children: _jsx(Image, { image: image }) }) })), showContent && (_jsxs(SectionContainer, { children: [_jsx(SectionTitle, { className: "nmb", children: pageTitle }), _jsxs(TextContent, { children: [featuredText && (_jsx("div", { children: _jsx("h2", { className: classNames({
                                        mt: !!pageTitle,
                                    }), children: featuredText }) })), completeDescription && (_jsx("div", { children: _jsx("p", { className: classNames({
                                        mt: !!pageTitle || !!featuredText,
                                    }), children: completeDescription }) }))] })] }))] }));
};
